import React from 'react'
import {
    BrowserRouter as Router,
    Redirect,
    withRouter,
    Route
  } from "react-router-dom";
import Header from "./Header"
import Footer from "./Footer"
import Home from "../pages/Home/index"
import { hasAnyRoleExist, setPanelHeight } from "../actions/utils";

class AdminLoginLayout extends React.Component {
    constructor(props)
    {
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }

    render() {
        if(localStorage.getItem('user') != null && hasAnyRoleExist("Admin"))
            {
                return (<Redirect
                            to={{
                                pathname: "/admin/user-list",
                                state: { from: this.props.location }
                            }}
                        />
                  );
            }

        return (
            <div>
                <Header />
                <Route exact path="/" component={Home} />
                <Footer />
            </div>
        );
    }
}

export default AdminLoginLayout;